import {
  CAMERA_ENCODED_MAX_LENGTH,
  isValidCameraEncoded,
  MODEL_ID_REGEX,
  type ParsedShareUrl,
} from './types.js';

const EMBED_PATH_REGEX = /^\/embed\/([^/?#]+)\/?$/;

function readCameraParam(searchParams: URLSearchParams): string | null {
  const raw = searchParams.get('cam');
  if (raw === null) return null;
  if (raw.length === 0 || raw.length > CAMERA_ENCODED_MAX_LENGTH) return null;
  if (!isValidCameraEncoded(raw)) return null;
  return raw;
}

export function parseShareUrl(href: string): ParsedShareUrl {
  let url: URL;
  try {
    url = new URL(href);
  } catch {
    return { kind: 'invalid', reason: 'unknown-route' };
  }

  const path = url.pathname.replace(/\/+$/, '') || '/';

  // /upload* → upload-fallback (anche /upload, /upload.html, /upload/foo)
  if (path === '/upload' || path.startsWith('/upload/') || path === '/upload.html') {
    return { kind: 'upload-fallback' };
  }

  // /embed/<id> → embed mode.
  // URL.pathname mantiene il percent-encoding (es. /embed/mdl%5F0123... non
  // decoded), quindi il segmento va decoded prima del match con MODEL_ID_REGEX.
  const embedMatch = EMBED_PATH_REGEX.exec(path);
  if (embedMatch) {
    const rawSegment = embedMatch[1] ?? '';
    let id: string;
    try {
      id = decodeURIComponent(rawSegment);
    } catch {
      return { kind: 'invalid', reason: 'malformed-id' };
    }
    if (!MODEL_ID_REGEX.test(id)) {
      return { kind: 'invalid', reason: 'malformed-id' };
    }
    return { kind: 'embed', modelId: id, cameraEncoded: readCameraParam(url.searchParams) };
  }

  // / con ?id=... → main
  if (path === '/' || path === '/index.html') {
    const id = url.searchParams.get('id');
    if (id === null || id === '') {
      return { kind: 'invalid', reason: 'no-id' };
    }
    if (!MODEL_ID_REGEX.test(id)) {
      return { kind: 'invalid', reason: 'malformed-id' };
    }
    return { kind: 'main', modelId: id, cameraEncoded: readCameraParam(url.searchParams) };
  }

  return { kind: 'invalid', reason: 'unknown-route' };
}
